import React, { useReducer, useContext, createContext, Dispatch } from "react";
import TableRowType from "../types/TableRowType";

type SelectedContextTypes = {
    clearAll: boolean;
    productLoading: boolean;
    mountingLoading: boolean;
    colorLoading: boolean;
    measurementsLoading: boolean;
    clearChildrenStates: boolean;
    summaryTable: TableRowType[];
    summaryTableLoading: boolean;
};

const initState: SelectedContextTypes = {
    clearAll: false,
    productLoading: false,
    mountingLoading: false,
    colorLoading: false,
    measurementsLoading: false,
    clearChildrenStates: false,
    summaryTable: [],
    summaryTableLoading: false
};

const SelectedContext = createContext(
    {} as [SelectedContextTypes, Dispatch<Action>]
);

export type Action = { type: string; payload: any };

function reducer(
    state: SelectedContextTypes,
    action: Action
): SelectedContextTypes {
    switch (action.type) {
        case "setClearAll":
            return { ...state, clearAll: action.payload };
        case "setProductLoading":
            return { ...state, productLoading: action.payload };
        case "setMountingLoading":
            return { ...state, mountingLoading: action.payload };
        case "setColorLoading":
            return { ...state, colorLoading: action.payload };
        case "setMeasurementsLoading":
            return { ...state, measurementsLoading: action.payload };
        case "setClearChildrenStates":
            return { ...state, clearChildrenStates: action.payload };
        case "setSummaryTable":
            return { ...state, summaryTable: action.payload };        
        case "setSummaryTableLoading":
            return { ...state, summaryTableLoading: action.payload };
    }

    return state;
}

function SelectedContextProvider({ children }: any) {
    return (
        <SelectedContext.Provider value={useReducer(reducer, initState)}>
            {children}
        </SelectedContext.Provider>
    );
}

function useSelectedContextState() {
    const context = useContext(SelectedContext);
    if (context === undefined) {
        throw new Error(
            "useSelectedContextState must be used within a SelectedContextProvider"
        );
    }
    return context;
}

export { SelectedContextProvider, useSelectedContextState };
